import { React, useContext, useState, useEffect } from "react";
import { AppContext } from "../contexts/AppContext";
import { functions } from "../firebase";
import { downloadFromStorage } from "../js/firebase/storage";
import infoIcon from "../assets/icons/info.svg";
import {
  angleInfo,
  xyHatchingInfo,
  beamAngleInfo,
  toothInfo,
} from "../config/info.js";
import refreshIcon from "../assets/icons/refresh.png";
import bookIcon from "../assets/icons/book.svg";
import overhangAngleInfoIcon from "../assets/images/support_angles_explanation.png";
import xyHatchingInfoIcon from "../assets/images/hatching.jpg";
import beamAngleInfoIcon from "../assets/images/beam_angle.png";
import toothInfoIcon from "../assets/images/tooth_area.jpg";
import temperatureIcon from "../assets/icons/temperature.svg";
import displacementIcon from "../assets/icons/displacement.svg";
import thermalStressIcon from "../assets/icons/thermal.svg";
import colormapDispl from "../assets/images/colormap_displ.png";
import colormapStress from "../assets/images/colormap_stress.png";
import colormapTemp from "../assets/images/colormap_temp.png";

// eslint-disable-next-line
const SettingsComponent = (props) => {
  const simulationTypesArray = [
    {
      id: "thermalStress",
      name: "Thermal Stress",
      isSelected: true,
      icon: thermalStressIcon,
      colormap: colormapStress,
    },
    {
      id: "temperature",
      name: "Temperature",
      isSelected: false,
      icon: temperatureIcon,
      colormap: colormapTemp,
    },
    {
      id: "displacement",
      name: "Displacement",
      isSelected: false,
      icon: displacementIcon,
      colormap: colormapDispl,
    },
  ];
  const [basicSettings, setBasicSettings] = useState({
    overhang_angle: 50,
    xy_hatching: 2.0,
    truss_width: 0.5,
    truss_angle: 45,
    tooth_height: 0.0,
    tooth_top_length: 0.0,
    support_thickness: 0.2,
  });
  const [advancedSettings, setAdvancedSettings] = useState({
    supportBorderDistance: 0.2,
    rayProjectionResolution: 0.1,
    simplifyPolygonFactor: 0.5,
    triangulationSpacing: 2.0,
    minimumAreaThreshold: 0.1,
    innerSupportEdgeGap: 0.1,
    outerSupportEdgeGap: 0.1,
  });
  const {
    file,
    setFile,
    setLoader,
    setInfo,
    setNotification,
    setTable,
  } = useContext(AppContext);
  // eslint-disable-next-line
  const [spinner, setSpinner] = useState("");
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [visibility, setVisiblity] = useState("hidden");
  const [orientation, setOrientation] = useState(1);
  const [selectedSimulationType, setSelectedSimulationType] = useState(
    simulationTypesArray[0]
  );
  const [simulationTypes, setSimulationTypes] = useState(simulationTypesArray);

  useEffect(() => {
    setSimulationTypes(
      simulationTypes.map((simulationType) => {
        if (simulationType.name === selectedSimulationType.name) {
          return selectedSimulationType;
        } else return { ...simulationType, isSelected: false };
      })
    );
    // eslint-disable-next-line
  }, [selectedSimulationType, file]);

  const onErr = (err) => {
    setNotification({ message: err, style: "alert" });
  };

  const loadStl = (requestSettings, fileName, view, displayedName) => {
    setLoader(true);
    let generateSupports = functions.httpsCallable("generateSupports", {
      timeout: 540 * 1000,
    });
    console.log(requestSettings);
    return new Promise((resolve, reject) => {
      generateSupports(requestSettings).then((response) => {
        console.log(response);
        if (response.data.statusCode === 200) {
          let fullName = fileName;
          downloadFromStorage(`objects/${file.id}/${fullName}`)
            .then((url) => {
              setFile({
                id: file.id,
                originalName: file.originalName,
                currentView: view,
                models: {
                  ...file.models,
                  [view]: {
                    name: displayedName,
                    format: "glb",
                    url: url,
                  },
                },
              });
            })
            .catch((err) => {
              onErr(err);
            });
        } else {
          onErr(response.data.statusCode);
        }
      });
    });
  };

  const loadSimulation = (fileName, view, displayedName) => {
    downloadFromStorage(`example_simulation_files/${fileName}`)
      .then((url) => {
        setFile({
          id: file.id,
          originalName: file.originalName,
          currentView: view,
          models: {
            ...file.models,
            [view]: {
              name: displayedName,
              format: "glb",
              url: url,
            },
          },
        });
      })
      .catch((err) => {
        onErr(err);
      });
  };

  const exportSTL = () => {
    downloadFromStorage(
      `objects/${file.id}/${file.id}_orientation${orientation}_support_structures.stl`
    ).then((url) => {
      const link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  const defineBasicSettings = (
    title,
    additionalElements,
    element,
    unit,
    additionalAction,
    integer
  ) => {
    return (
      <>
        <span>
          <label>{title} </label>
          {additionalElements}
          <div className={unit + "-container"}>
            <input
              type="text"
              value={basicSettings[element]}
              // onChange={(e) => {
              //   let possibleAngle = parseFloat(e.target.value.split("°")[0]);
              //   if (!isNaN(possibleAngle)) setAngle(possibleAngle);
              // }}
              // TODO: FIX INVALID INPUT HANDLING! Perhaps validation on button press(?)
              onChange={(e) => {
                let newValue;
                if (e.target.value === "") newValue = 0;
                else newValue = e.target.value;
                if (integer) {
                  setBasicSettings({
                    ...basicSettings,
                    [element]: parseInt(newValue),
                  });
                } else {
                  if (newValue !== 0 && !newValue.endsWith(".")) {
                    newValue = parseFloat(newValue);
                  }

                  setBasicSettings({
                    ...basicSettings,
                    [element]: newValue,
                  });
                }
                additionalAction !== null && additionalAction();
              }}
            ></input>
          </div>
        </span>
      </>
    );
  };

  let generateButton =
    file &&
    (file.currentView === "partView" || file.currentView === "supportsView")
      ? "accent-button"
      : "accent-button disabled";
  let simulateButton =
    file && file.currentView === "supportsView"
      ? "accent-button"
      : "accent-button disabled";
  let exportButton =
    file && file.currentView === "supportsView"
      ? "accent-button"
      : "accent-button disabled";

  let generalSettingsFormat = (
    <>
      <panel-support-areas>
        <select
          onChange={(e) => {
            if (file.currentView === "partView") {
              setOrientation(e.target.value);
              downloadFromStorage(
                `objects/${file.id}/${file.id}_orientation${e.target.value}_support_areas.glb`
              )
                .then((url) => {
                  setFile({
                    id: file.id,
                    originalName: file.originalName,
                    currentView: file.currentView,
                    models: {
                      ...file.models,
                      partView: {
                        name: `${file.originalName}_orientation${e.target.value}_support_areas`,
                        format: "glb",
                        url: url,
                      },
                    },
                  });
                })
                .catch((err) => {
                  onErr(err);
                });
            } else if ((file.currentView = "supportsView")) {
              downloadFromStorage(
                `objects/${file.id}/${file.id}_orientation${e.target.value}_support_structures.glb`
              )
                .then((url) => {
                  setFile({
                    id: file.id,
                    originalName: file.originalName,
                    currentView: file.currentView,
                    models: {
                      ...file.models,
                      supportsView: {
                        name: `${file.originalName}_orientation${e.target.value}_support_structures`,
                        format: "glb",
                        url: url,
                      },
                    },
                  });
                })
                .catch((err) => {
                  onErr("File has not been generated");
                  setFile({
                    id: file.id,
                    originalName: file.originalName,
                    currentView: file.currentView,
                    models: {
                      ...file.models,
                      supportsView: undefined,
                    },
                  });
                });
            }
          }}
        >
          {Array(11)
            .fill()
            .map((el, i) => {
              return (
                <option value={i + 1} key={i + 1}>
                  Orientation {i + 1}
                </option>
              );
            })}
        </select>
        <div>
          {defineBasicSettings(
            "Surface Angle",
            <img
              id="info"
              src={infoIcon}
              alt="info"
              onClick={() =>
                setInfo({
                  text: angleInfo,
                  icon: overhangAngleInfoIcon,
                })
              }
            ></img>,
            "overhang_angle",
            "degree",
            () => setVisiblity("visible"),
            true
          )}
        </div>
        <img
          style={{ visibility: visibility }}
          alt="refresh"
          src={refreshIcon}
          id="refresh"
          className={spinner}
          onClick={() => {
            // setSpinner("spin");
            loadStl(
              {
                part_id: file.id,
                orientation: `orientation${orientation}`,
                options: ["support_areas", "orientations"],
                settings: { ...basicSettings, ...advancedSettings },
              },
              `${file.id}_orientation${orientation}_support_areas.glb`,
              "partView",
              file.originalName + `_orientation${orientation}_support_areas`
            ).then(() => {
              setVisiblity("hidden");
              // setSpinner("");
            });
          }}
        ></img>
      </panel-support-areas>
      <hr className="solid"></hr>
      <panel-supports>
        <img
          id="book"
          src={bookIcon}
          alt="book"
          onClick={() => setTable(true)}
        ></img>
        <div className="border">
          <div id="borderTop"></div>
          <img
            id="infoGroup"
            src={infoIcon}
            alt="info"
            onClick={() =>
              setInfo({
                text: xyHatchingInfo,
                icon: xyHatchingInfoIcon,
              })
            }
          ></img>
          {defineBasicSettings(
            "X,Y Hatching",
            "",
            "xy_hatching",
            "mm",
            null,
            false
          )}
          <div id="borderBottom"></div>
        </div>
        <div className="border">
          <div id="borderTop"></div>
          <img
            id="infoGroup"
            src={infoIcon}
            alt="info"
            onClick={() =>
              setInfo({
                text: beamAngleInfo,
                icon: beamAngleInfoIcon,
              })
            }
          ></img>

          {defineBasicSettings("Beam", "", "truss_width", "mm", null, false)}
          {defineBasicSettings(
            "Angle",
            "",
            "truss_angle",
            "degree",
            null,
            true
          )}
          <div id="borderBottom"></div>
        </div>
        <div className="border">
          <div id="borderTop"></div>
          <img
            id="infoGroup"
            src={infoIcon}
            alt="info"
            onClick={() => setInfo({ text: toothInfo, icon: toothInfoIcon })}
          ></img>
          {defineBasicSettings(
            "Tooth Height",
            "",
            "tooth_height",
            "mm",
            null,
            false
          )}
          {defineBasicSettings(
            "Tooth Top Length",
            "",
            "tooth_top_length",
            "mm",
            null,
            false
          )}
          <div id="borderBottom"></div>
        </div>

        <div className="border">
          <div id="borderTop"></div>
          {defineBasicSettings(
            "Support Thickness",
            "",
            "support_thickness",
            "mm",
            null,
            false
          )}
          <div id="borderBottom"></div>
        </div>
        <span
          className="hover"
          onClick={() =>
            setShowAdvanced((prevShowAdvanced) => {
              return !prevShowAdvanced;
            })
          }
        >
          <label id="advanced">Advanced Settings </label>
          <span className={showAdvanced ? "open" : ""}>
            <span className="left-bar"></span>
            <span className="right-bar"></span>
          </span>
        </span>
        {showAdvanced && (
          <textarea
            rows="7"
            cols="50"
            onChange={(e) => {
              try {
                let newAdvancedSettings = JSON.parse(e.target.value);
                setAdvancedSettings(newAdvancedSettings);
              } catch (e) {}
            }}
          >
            {JSON.stringify(advancedSettings, undefined, 4)}
          </textarea>
        )}
      </panel-supports>
    </>
  );

  let simulationTypesList =
    simulationTypes !== undefined &&
    simulationTypes.map((simulationType, index) => {
      return (
        <>
          <li id={simulationType.id} key={index}>
            <span
              className={simulationType.isSelected ? "highlight" : ""}
              onClick={(e) => {
                downloadFromStorage(
                  `example_simulation_files/simulation_${simulationType.id}.glb`
                ).then((url) => {
                  setFile((prevFile) => {
                    return {
                      ...prevFile,
                      models: {
                        ...prevFile.models,
                        [prevFile.currentView]: {
                          name: `simulation_${simulationType.id}`,
                          format: "glb",
                          url: url,
                        },
                      },
                    };
                  });
                });
                simulationTypes.map((simulationType) => {
                  if (simulationType.name === e.target.innerText) {
                    setSelectedSimulationType({
                      ...simulationType,
                      isSelected: true,
                    });
                  }
                  return simulationType;
                });
              }}
            >
              {simulationType.name}
            </span>
            <img
              className="indicator"
              src={simulationType.icon}
              alt="simulationIcon"
            ></img>
          </li>
          {index < simulationTypes.length - 1 && <hr className="solid"></hr>}
        </>
      );
    });

  let simulationSettingsFormat = <ul>{simulationTypesList}</ul>;

  let buttons = (
    <panel-footer>
      <button
        className={generateButton}
        onClick={
          file &&
          (file.currentView === "partView" ||
            file.currentView === "supportsView")
            ? () =>
                loadStl(
                  {
                    part_id: file.id,
                    orientation: "orientation" + orientation,
                    options: [
                      "orientations",
                      "support_areas",
                      "support_structures",
                    ],
                    settings: { ...basicSettings, ...advancedSettings },
                  },
                  `${file.id}_orientation${orientation}_support_structures.glb`,
                  "supportsView",
                  file.originalName +
                    `_orientation${orientation}_support_structures`
                )
            : undefined
        }
      >
        Generate
      </button>
      <button
        className={simulateButton}
        onClick={
          file && file.currentView === "supportsView"
            ? () =>
                loadSimulation(
                  "simulation_thermalStress.glb",
                  "simulationView",
                  "simulation_thermalStress"
                )
            : undefined
        }
      >
        Simulate
      </button>
      <button
        className={exportButton}
        onClick={
          file && file.currentView === "supportsView"
            ? () => exportSTL()
            : undefined
        }
      >
        Export
      </button>
    </panel-footer>
  );
  return (
    <>
      {file && (
        <>
          <div className={"panel card "}>
            {file.currentView === "simulationView" && (
              <img
                id={selectedSimulationType.id}
                className="colormap"
                src={selectedSimulationType.colormap}
                alt="colormap"
              ></img>
            )}
            <panel-title id="settings">
              <span>Settings</span>
            </panel-title>
            <panel-body className={showAdvanced ? "open" : "closed"}>
              {file.currentView !== "simulationView"
                ? generalSettingsFormat
                : simulationSettingsFormat}
              <hr className="solid"></hr>
              {buttons}
            </panel-body>
          </div>
        </>
      )}
    </>
  );
};
export default SettingsComponent;
